import { useQuery } from "@tanstack/react-query";

import { kpiService } from "../../services/kpiService";
import type { Kpi } from "../../types";

export const useKpis = () => {
  return useQuery<Kpi[]>({
    queryKey: ["kpis"],
    queryFn: async () => kpiService.list(),
  });
};
